import { StyleEntry } from 'Shared/backend/styleUtils';

//TODO? structure as a category tree if the concept appears to work. This should allow names to be scoped within their categories and subcategories...

export function textStyles(sizes,text): {[name: string]: StyleEntry}
{
	return {
		'Page title': {
			explanation: 'Converts a title to page title.',

			rules: [{
				location: () => ['text:title'],
				css: () => text.pageTitle
			}]
		},
	};
}

